module.exports = "/fonts/Montserrat-SemiBold.ttf?c641dbee1d75892e4d88bdc31560c91b";